<template>
  <v-layout align-center justify-center>
      <v-card >
        <v-toolbar dark color="primary">
          <v-toolbar-title>Liability Waiver</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <v-card-text v-if="!saveIt">
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12 class="headline text-xs-center">
                RENO RODEO BSD
              </v-flex>
              <v-flex xs12 class="subheading text-xs-center mb-4">
                RELEASE AND WAIVER OF LIABILITY AND INDEMNITY AGREEMENT
              </v-flex>
              <v-flex xs12>
                <b>NAME OF INSURED:</b> RENO RODEO
              </v-flex>
              <v-flex xs12>
              <b>NAME AND LOCATION OF RODEO:</b> RENO LIVESTOCK EVENTS CENTER, RENO, NEVADA
              </v-flex>
              <v-flex xs12>
                <b>IN CONSIDERATION</b> of being permitted to enter for any purpose to any RESTRICTED AREA (herein defined as including but not
                limited to the rodeo arena, competition area, chutes, pens, areas reserved and intended for participants or restricted
                to the general public, and all walkways, concessions and other areas appurtenant to any area where any activity related
                to the event shall take place), or being permitted to compete, officiate, observe, work for, or any purpose participate
                in any way in the event, EACH OF THE UNDERSIGNED, for himself, his personal representatives, heirs, and next of kin,
                acknowledges, agrees and represents that he has, or will immediately upon entering any of such restricted areas, and will
                continuously thereafter, inspect such restricted areas and all portions thereof which he enters and with which he comes
                in contact, and he does further warrant that his entry upon such restricted area or areas and his participation, if any,
                in the event constitutes an acknowledgement that he has inspected such restricted area and that he finds and accepts the
                same as being safe and reasonably suited for the purposes of his use, and he further agrees and warrants if, at any time,
                he is in or about restricted areas and he feels anything to be unsafe, he will immediately advise the officials or such
                and will leave the restricted areas.
              </v-flex>
              <v-flex xs12>
                <ol>
                  <li>
                    <b>HEREBY RELEASES, WAIVES, DISCHARGES, AND COVENANTS NOT TO SUE</b> the participants, sanctioning organization or any
                    subdivision thereof, rodeo committee, stock contractor, rodeo association, arena operators or owners, officials,
                    any persons in any restricted area, promoters, sponsors, advertisers, owners and lessees of premises used to conduct
                    the event and each of them, their officers and employees, all for the purpose herein referred to as “releases”, from
                    all liability to the undersigned, his personal representatives, assigns, heirs, and next of kin for any and all loss or
                    damage, and any claim or demands therefor on account of injury to the person or property or resulting in death of the
                    undersigned, whether caused by the negligence of the releasees or otherwise while the undersigned is in or upon the
                    restricted are, and/or, competing, officiating in, observing, working for, or for any purpose participating in the event.
                  </li>
                  <li>
                    <b>HEREBY AGREES TO INDEMNIFY AND SAVE AND HOLD HARMLESS</b> the releases and each of them from any loss, liability, damage,
                    or cost they may incur due to the presence of the undersigned in or upon the restricted area or in any way competing,
                    officiating, observing, or working for, or for any purpose participating in the event and whether caused by the negligence
                    of the releasees or otherwise.
                  </li>
                  <li>
                    <b>HEREBY ASSUMES FULL RESPONSIBILITY FOR AND RISK OF BODILY INJURY, DEATH OR PROPERTY DAMAGE</b> due to the negligence of
                    releasees or otherwise while in or upon the restricted area and/or while competing, officiating, observing, or working
                    for or for any purpose participating in the event.
                  </li>
                </ol>
              </v-flex>
              <v-flex xs12>
                <b>EACH OF THE UNDERSIGNED</b> expressly acknowledges and agrees that the activities of the event are very dangerous and involve
                the risk of serious injury and/or death and/or property damage. EACH OF THE UNDERSIGNED further expressly agrees that the
                foregoing release, waiver, and indemnity agreement is intended to be as broad and inclusive as is permitted by the laws of
                the State of Nevada in which the Reno Rodeo is conducted and that if any portion thereof is held invalid, it is agreed
                that the balance shall, notwithstanding, continue in full legal force and effect.
              </v-flex>
              <v-flex xs12>
                <b>THE UNDERSIGNED HAS READ AND VOLUNTARILY SIGNS THE RELEASE AND WAIVER OF LIABILITY AND INDEMNITY AGREEMENT</b>, and further
                agrees that no oral representations, statements, or inducements apart from the foregoing written agreement have been made.
              </v-flex>
              <v-flex xs12>
              <b>I HAVE READ THIS DOCUMENT. I UNDERSTANT IT IS A RELEASE OF ALL CLAIMS.</b>
              </v-flex>
              <v-flex xs12>
              <b>I UNDERSTAND I ASSUME ALL RISK INHERENT IN RODEO.</b>
              </v-flex>
              <v-flex xs12>
                <b>I VOLUNTARILY SIGN MY NAME EVIDENCING MY ACCEPTANCE OF THE ABOVE PROVISIONS.</b>
              </v-flex>
              <v-flex xs12>
                <b>THIS IS A RELEASE</b>
              </v-flex>
              <v-flex xs12 md6 offset-md6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formattedDate"
                    label="Date"
                    readonly
                    @change="editedItem.birthDate = parseDate(formattedDate)"
                    v-validate="'required'"
                    :error-messages="errors.collect('Birth Date')"
                    data-vv-name="Birth Date"
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="editedItem.birthDate"
                    no-title
                    @input="menu1 = false"
                    @change="formattedDate = formatDate(editedItem.birthDate)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.firstName"
                  label="First Name"
                  v-validate="'required'"
                  :error-messages="errors.collect('First Name')"
                  data-vv-name="First Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.lastName"
                  label="Last Name"
                  v-validate="'required'"
                  :error-messages="errors.collect('Last Name')"
                  data-vv-name="Last Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-flex xs6 md3>
                <v-select
                  v-model="editedItem.type"
                  :items="types"
                  label="Contestant/ Parent"
                ></v-select>
              </v-flex>

              </v-flex>
              <v-flex xs12>
                <b>Signature</b><br />
              </v-flex>
              <v-flex xs12>
                <canvas
                ref="canvas"
                @mousedown="startDrawing"
                @mousemove="draw"
                @mouseup="stopDrawing"
                @touchstart="startDrawing"
                @touchmove="draw"
                @touchend="stopDrawing"
                width="600px"
                height="150px"
                ></canvas>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text v-else>
          Your Waiver has been successfully submited. Thank you.<br />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="!saveIt" @click="save()">Accept</v-btn>
          <v-btn color="primary" v-else @click="saveIt = !saveIt">Back to form</v-btn>
        </v-card-actions>
      </v-card>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'

function getOffsetSum (element) {
  let curleft = 0
  let curtop = 0

  if (element.offsetParent) {
    do {
      curleft += element.offsetLeft
      curtop += element.offsetTop
      element = element.offsetParent
    } while (element)
  }

  return { x: curleft, y: curtop }
}

export default {
  $_veeValidate: {
    validator: 'new'
  },

  data: () => ({
    currentPage: 'Liability',
    menu1: false,
    userId: 0,
    name: '',
    types: ['Contestant', 'Parent'],
    canvas: null,
    saveIt: false,
    filename: null,
    currentYear: 0,
    editedItem: {},
    formattedDate: '',
    id: null,
    drawing: false,
    context: null,
    lastX: 0,
    lastY: 0,
    image: null,
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.currentYear = moment().format('YYYY')

    this.editedItem.birthDate = moment().format('YYYY-MM-DD')
    this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
  },

  mounted () {
    this.context = this.$refs.canvas.getContext('2d')
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        console.log('test')
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        console.log('test')
        this.saving = true
      },
      deep: true
    // },
    // menu1 (val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },

  methods: {
    handleFileUploads (e) {
      const reader = new FileReader()
      reader.onloadend = () => (this.id = reader.result)
      reader.readAsDataURL(e.target.files[0])
      console.log(e.target.files[0])
      this.filename = e.target.files[0].name
    },

    close (image) {
      this.canvas = image
    },

    save () {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.saving = false
          this.snackbar.message = 'There were errors in the form'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else if (!this.image) {
          this.saving = false
          this.snackbar.message = 'You must sign the form'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else {
          this.acceptLiability()
        }
      })
    },

    async acceptLiability () {
      try {
        this.editedItem.sign = this.image
        this.editedItem.currentYear = this.currentYear

        console.log(this.editedItem)

        const response = await Api().post('set_liability', this.editedItem)

        this.editedItem = {}
        this.formattedDate = ''
        this.saveIt = true

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    startDrawing (event) {
      event.preventDefault()
      this.drawing = true

      if (event.touches) {
        let offset = getOffsetSum(event.touches[0].target)
        console.log(offset)
        this.lastX = event.touches[0].pageX - offset.x
        this.lastY = event.touches[0].pageY - offset.y
      } else {
        this.lastX = event.offsetX
        this.lastY = event.offsetY
      }
    },

    draw (event) {
      event.preventDefault()
      if (!this.drawing) return

      let currentX = null
      let currentY = null

      this.context.beginPath()
      this.context.moveTo(this.lastX, this.lastY)
      if (event.touches) {
        let offset = getOffsetSum(event.touches[0].target)
        currentX = event.touches[0].pageX - offset.x
        currentY = event.touches[0].pageY - offset.y
      } else {
        currentX = event.offsetX
        currentY = event.offsetY
      }

      this.context.lineTo(currentX, currentY)
      this.context.stroke()
      // const img = this.$el.toDataURL('image/png').replace('image/png', 'image/octet-stream')
      // this.image = img
      this.lastX = currentX
      this.lastY = currentY
    },

    stopDrawing () {
      this.drawing = false
      this.image = this.$refs.canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
      console.log(this.image)
    },

    clear () {
      this.context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
    }
  }
}
</script>

<style scoped>
canvas {
  border: 2px dotted #CCCCCC;
  border-radius: 5px;
  cursor: crosshair;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/bsd/Liability.vue